import { put, call } from 'redux-saga/effects';
import { feedbackFilterEventsList,feedbackFilterReviewersList } from '../services/filterService';

import * as types from '../actions';

export function* feedbackFilterEventsListSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(feedbackFilterEventsList, payload);
    yield put({ type: types.FEEDBACK_FILTER_EVENTS_LIST_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.FEEDBACK_FILTER_EVENTS_LIST_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* feedbackFilterReviewersListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(feedbackFilterReviewersList, payload);
      yield put({ type: types.FEEDBACK_FILTER_REVIEWERS_LIST_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.FEEDBACK_FILTER_REVIEWERS_LIST_ERROR, error });
    }finally{
        yield put({ type: types.HIDE_LOADER})
    }
  }



